export enum PowerBiReportTypes {
  Report = 1,
  Dashboard = 2
}
